import React from "react";




const WaxtoMetalConversion = () => {

    const data = [
        ["Wax Resin", "12.000", "21.211", "18.737", "16.632", "15.948", "16.422", "14.369", "13.264", "11.895", "11.685", "10.895", "1.000", "1.000"],
        ["Sterling Silver", "1.101", "1.980", "1.745", "1.545", "1.480", "1.525", "1.385", "1.330", "1.225", "1.095", "1.000", "0.092", "0.092"],
        ["9ct Yellow", "1.027", "1.905", "1.670", "1.470", "1.405", "1.450", "1.310", "1.255", "1.150", "1.075", "0.933", "0.086", "0.086"],
        ["9ct Red", "1.009", "1.885", "1.650", "1.450", "1.385", "1.430", "1.290", "1.235", "1.130", "0.983", "0.916", "0.085", "0.085"],
        ["9ct White", "0.905", "1.755", "1.520", "1.320", "1.255", "1.300", "1.160", "1.105", "1.000", "0.897", "0.822", "0.076", "0.076"],
        ["14ct Yellow", "0.835", "1.650", "1.415", "1.215", "1.150", "1.195", "1.055", "1.000", "0.895", "0.824", "0.759", "0.070", "0.070"],
        ["14ct White", "0.80", "1.595", "1.360", "1.160", "1.095", "1.140", "1.000", "0.945", "0.840", "0.762", "0.703", "0.067", "0.067"],
        ["18ct Yellow (2N)", "0.731", "1.455", "1.220", "1.020", "0.972", "1.000", "0.867", "0.815", "0.725", "0.664", "0.607", "0.059", "0.059"],
        ["18ct Red (5N)", "0.752", "1.500", "1.265", "1.065", "1.000", "1.050", "0.900", "0.845", "0.745", "0.675", "0.614", "0.060", "0.060"],
        ["18ct White (High P. 13.5%)", "0.722", "1.435", "1.200", "1.000", "0.959", "0.988", "0.850", "0.798", "0.716", "0.655", "0.602", "0.057", "0.057"],
        ["22ct Yellow", "0.640", "1.235", "1.000", "0.888", "0.852", "0.877", "0.747", "0.695", "0.610", "0.554", "0.506", "0.054", "0.054"],
        ["Platinum (950)", "0.566", "1.000", "0.884", "0.785", "0.775", "0.800", "0.675", "0.625", "0.525", "0.461", "0.514", "0.052", "0.052"],
        ["Palladium (950)", "1.000", "1.768", "1.561", "1.386", "1.329", "1.369", "1.197", "1.105", "0.991", "0.974", "0.908", "0.075", "0.075"],
    ];

    const headers = ["", "Palladium (950)", "Platinum (950)", "22ct Yellow", "18ct White (High P. 13.5%)", "18ct Red (5N)", "18ct Yellow (2N)", "14ct Yellow", "14ct White", "9ct Yellow", "9ct Red", "9ct White", "Sterling Silver", "Wax Resin"];


    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="card">
                    <div className="container mt-5">
                        <table className="table table-bordered">
                            <thead className="thead-light">
                                <tr style={{backgroundColor: "#f2f2f2"}}>
                                    <th>Metal</th>
                                    <th>Palladium (950)</th>
                                    <th>Platinum (950)</th>
                                    <th>22ct Yellow</th>
                                    <th>18ct White (High P. 13.5%)</th>
                                    <th>18ct Red (5N)</th>
                                    <th>18ct Yellow (2N)</th>
                                    <th>14ct Yellow</th>
                                    <th>14ct White</th>
                                    <th>9ct Yellow</th>
                                    <th>9ct Red</th>
                                    <th>9ct White</th>
                                    <th>Sterling Silver</th>
                                    <th>Wax</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((row, index) => (
                                    <tr key={index}>
                                        {row.map((cell, cellIndex) => (
                                            <td key={cellIndex}>{cell}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default WaxtoMetalConversion;